<template>
    <div>
      <div class="whiteBox" style="display: flex;align-items: center;justify-content: space-between;">
        <div style="display: flex;align-items: flex-end;">
            <div class="title ">{{ $t('view.企业信息') }}</div>
            <el-button @click="$refs.Information.certificationDis=false;$refs.Information.scrollSupplyTypeSection()" v-if="form.isTypeAndBrandReview==1&&!this.$route.query.sectionId" style="min-width: 120px;margin-left: 30px;" type="primary">{{$t('view.变更供货类型') }}</el-button>
        </div>
        <el-button style="min-width: 120px;" type="primary"  v-if="enterpriseCategory==1" @click="changeEnterpriseCategoryNonIndonesian()">{{$t('view.转为国内供应商') }}</el-button>

    </div>
      <div class="whiteBox" v-if="enterpriseCategory!=1">
        <Information ref="Information" :disabled="true" :btnShow="false" :ChildForm="form"></Information>
      </div>
      <div class="whiteBox" v-else>
        <el-form ref="form" :model="form" label-width="120px" style="display: flex;flex-wrap: wrap;">
          <div class="title" style="width: 100%;margin-bottom: 10px;">{{ $t('view.公司信息') }}</div>
          <el-form-item :label="$t('view.供应商名称')" prop="declareName">
              <el-input style="width: 320px;" v-model="form.declareName" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('view.供应商简称')" prop="simpleName">
              <el-input style="width: 320px;" v-model="form.simpleName" disabled></el-input>
          </el-form-item>
            <el-form-item prop="nickName" :label="$t('view.企业类别')">
              <el-radio-group v-model="form.enterpriseCategory" disabled style="width: 760px;">
                  <el-radio :label="0">{{ $t('view.国内供应商') }}</el-radio>
                  <el-radio :label="1">{{ $t('view.印尼供应商') }}</el-radio>
              </el-radio-group>                
          </el-form-item>
        </el-form>
      </div>
    </div>
  </template>
    
<script>
import {getAuthorization,authorizationVerify,changeEnterpriseCategoryNonIndonesian,authorizationDownLoad,getAuthorizationByRaxCode,getByUser} from '@/api/project'
import Information from './Information.vue';
import Personal from './Personal.vue';
import {profileGetInfo} from '@/api/login'

  export default {
    components:{Information,Personal},
    data(){
      return{
        form:{
            businessLicenseFileList:[],
            agencyLicenseFileList:[],
            productionLicenseFileList:[],
            threeYearsFinancialReprotFileList:[],
            corporateIdCardFront:[],
            corporateIdCardOpposite:[],
            authorizationFileList:[],
        },    
        active:0,
        disabled:false,
        feedback:'',
        btnDis:'',
        enterpriseCategory:'',//是否为印尼供应商 1是
      }
    },
    created(){
        // 获取用户信息
        profileGetInfo().then(res=>{
            this.enterpriseCategory=res.data.enterpriseCategory
            getByUser().then(res=>{
                this.form=res.data
                this.$set(this.form,'typeAndBrand',this.form.typeAndBrand?JSON.parse(this.form.typeAndBrand): [])
                this.$set(this.form,'declareName',this.form.name)
                this.$set(this.form,'declareName',this.form.name)
                this.$set(this.form,'bankNo',this.form.bankCode)

                
                this.form.enterpriseCategory=this.enterpriseCategory*1
            })
            // if(this.enterpriseCategory!=1)
            // this.authorizationVerify()
        }) 
    },
    methods:{
          changeEnterpriseCategoryNonIndonesian(){
            let that=this
            this.$confirm(this.$t('view.是否转为国内供应商'), that.$t('view.提示'), {
                confirmButtonText:that.$t('view.确定'),
                cancelButtonText: that.$t('view.取消'),
                type: 'warning'
            }).then(() => {
                changeEnterpriseCategoryNonIndonesian().then(res=>{
                    location.reload()
                })
            })
        },
        chose(e){
            if(this.btnDis=='modify'||this.btnDis=='prompt')
            this.active=e
        },
        nextStep(e){
            this.form={...this.from,...e}
            this.active+=1
        },
        authorizationVerify(){
            authorizationVerify().then(res=>{
                this.btnDis=res.data.operation
                this.disabled=this.btnDis=='prompt'||this.btnDis=='skip'
                this.active=this.btnDis=='skip'?4:this.btnDis=='modify'?3:this.btnDis=='Auth'?1:3
                this.feedback=res.data.operationContent?res.data.operationContent:'信息正在审核中'
                if(this.btnDis=='Auth'){
                    this.getAuthorizationByRaxCode()
                }else{
                    this.getAuthorization()
                }
                
                // 审核中  审核通过 不可编辑
                // if(res.data.operation =='prompt' ||res.data.operation== 'skip')
            })
        },  
        getAuthorizationByRaxCode(){
            getAuthorizationByRaxCode().then(res=>{
                if(res.data)
                this.form=res.data
                this.form.agencyLicenseFileList=this.form.agencyLicenseFileList?this.form.agencyLicenseFileList:[]
                this.form.productionLicenseFileList=this.form.productionLicenseFileList?this.form.productionLicenseFileList:[]
                this.form.threeYearsFinancialReprotFileList=this.form.threeYearsFinancialReprotFileList?this.form.threeYearsFinancialReprotFileList:[]
                this.form.corporateIdCardOpposite=this.form.corporateIdCardOpposite?this.form.corporateIdCardOpposite:[]
                this.form.corporateIdCardFront=this.form.corporateIdCardFront?this.form.corporateIdCardFront:[]
                this.form.authorizationFileList=this.form.authorizationFileList?this.form.authorizationFileList:[]
                this.form.businessLicenseFileList=this.form.businessLicenseFileList?this.form.businessLicenseFileList:[]
                this.$set(this.form,'declareName',this.$store.getters.companyName)
                this.$set(this.form,'tin',this.$store.getters.tin)
                if(!this.form.name)
                this.$set(this.form,'name',this.$store.getters.name)
                this.form.mobile=this.$store.getters.phonenumber
                this.form.email=this.$store.getters.userEmail 
                this.$set(this.form,'typeAndBrand',this.form.typeAndBrand?JSON.parse(this.form.typeAndBrand): [])
                if(this.$route.query.projectMaterialType){
                    this.form.typeAndBrand.push({SupplyType:this.$route.query.projectMaterialTypeName, dictValue:this.$route.query.projectMaterialType ,brand:''})
                }
                if(!this.form.authorizationContactsList||this.form.authorizationContactsList.length==0)
                this.$set(this.form,'authorizationContactsList',[{typeName:this.$t('view.单位管理人'),type:1},{typeName:this.$t('view.合同签订人'),type:2},{typeName:this.$t('view.采购业务员'),type:3}])
                //this.form.bpmIdStr= '1798678076754890752,1798678266236768256'
                //this.form.bpmNameStr= '田涛,胡善鑫'
                if(this.btnDis=='Auth'){
                    this.form.isLegalRepresentative=''
                    this.form.authorizationEnd=''
                    this.form.authorizationStart=''
                    this.form.authorizationFileList=[]
                    this.form.id=null
                    this.form.instanceId=null
                    this.form.taskId=null
                    // this.form.sectionName=''
                   // this.form.bpmIdStr='' 
                    //this.form.bpmNameStr=''
                }
                this.form.enterpriseCategory=this.enterpriseCategory*1
            })
        },
        getAuthorization(){
            getAuthorization().then(res=>{
                if(res.data)
                this.form=res.data
                this.form.agencyLicenseFileList=this.form.agencyLicenseFileList?this.form.agencyLicenseFileList:[]
                this.form.productionLicenseFileList=this.form.productionLicenseFileList?this.form.productionLicenseFileList:[]
                this.form.threeYearsFinancialReprotFileList=this.form.threeYearsFinancialReprotFileList?this.form.threeYearsFinancialReprotFileList:[]
                this.form.corporateIdCardOpposite=this.form.corporateIdCardOpposite?this.form.corporateIdCardOpposite:[]
                this.form.corporateIdCardFront=this.form.corporateIdCardFront?this.form.corporateIdCardFront:[]
                this.form.authorizationFileList=this.form.authorizationFileList?this.form.authorizationFileList:[]
                this.form.businessLicenseFileList=this.form.businessLicenseFileList?this.form.businessLicenseFileList:[]
                this.$set(this.form,'declareName',this.$store.getters.companyName)
                this.$set(this.form,'tin',this.$store.getters.tin)
                if(!this.form.name)
                this.$set(this.form,'name',this.$store.getters.name)
                this.form.mobile=this.$store.getters.phonenumber
                this.form.email=this.$store.getters.userEmail 
                this.$set(this.form,'typeAndBrand',this.form.typeAndBrand?JSON.parse(this.form.typeAndBrand): [])
                if(this.$route.query.projectMaterialType){
                    this.form.typeAndBrand.push({SupplyType:this.$route.query.projectMaterialTypeName, dictValue:this.$route.query.projectMaterialType ,brand:''})
                }
                if(!this.form.authorizationContactsList||this.form.authorizationContactsList.length==0)
                this.$set(this.form,'authorizationContactsList',[{typeName:this.$t('view.单位管理人'),type:1},{typeName:this.$t('view.合同签订人'),type:2},{typeName:this.$t('view.采购业务员'),type:3}])
                //this.form.bpmIdStr= '1798678076754890752,1798678266236768256'
                //this.form.bpmNameStr= '田涛,胡善鑫'
                if(this.btnDis=='Auth'){
                    this.form.isLegalRepresentative=''
                    this.form.authorizationEnd=''
                    this.form.authorizationStart=''
                    this.form.authorizationFileList=[]
                    this.form.id=null
                    this.form.instanceId=null
                    this.form.taskId=null
                    // this.form.sectionName=''
                   // this.form.bpmIdStr='' 
                    //this.form.bpmNameStr=''
                }
                this.form.enterpriseCategory=this.enterpriseCategory*1

            })
        },
    }
};
  </script>
  <style>
  .line20 .el-form-item__label{
    line-height: 20px !important;
  }
  </style>
  <style lang="scss" scoped>
  ::v-deep.hide .el-upload--picture-card {
    display: none;
  }
  ::v-deep.hide .el-upload--text{
      display: none;
  }
  .annexList{
      display: flex;
      margin-bottom: 20px;
      font-size: 14px;
      color: #303133;
      div:first-child{
          color: #909399;        
      }
  }
  .title{
      font-size: 16px;
      font-weight: 600;
      color: #333333;
  }
  .approvalComments{
    position: fixed;
    right: 10px;
    background: #fff;
    height: 200px;
    overflow-y: auto;
    padding: 20px;
    width: calc((100vw - 1400px) / 2);
    top: 370px;
  }
  </style>
   